const predictionReducer = (state, action) => {

    switch (action.type) {
        case "LOAD_PREDICTION":
            return { prediction: action.payload }
        case "LOAD_PREDICTIONANSWER":
            return { predictionAnswer: action.payload }
        case "ADD_PREDICTION":
            return {
                prediction: [...state.prediction, action.payload]
            };
        case "UPDATE_PREDICTION":
            let newVal = action.payload;
            let newPrediction = state.prediction;
            let idx = state.prediction.findIndex((p) => p._id === newVal._id);
            if(idx > -1){
                newPrediction[idx] = newVal;
            }
            return { prediction: newPrediction };

        default:
            return { 
                prediction: state.prediction,
                predictionAnswer: state.predictionAnswer
            }
    }
};
  
export default predictionReducer